import { useState } from 'react';
import { Link } from 'react-router-dom';

import BarChartFilters from 'entities/Charts/components/BarChartFilters';
import BarChartTabs from 'entities/Charts/components/BarChartTabs';
import CoOccurrenceMisconception from 'entities/Charts/components/CoOccurrenceMisconception';
import MisconceptionsBarChart from 'entities/Charts/components/MisconceptionsBarChart';
import OverallResponseBarChart from 'entities/Charts/components/OverallResponseBarChart';
import OverallResponseDistributionBarChart from 'entities/Charts/components/OverallResponseDistributionBarChart';
import SampleQuestions from 'entities/Charts/components/SampleQuestions';
import ScoresPDF from 'entities/Charts/components/ScoresPDF';
import SubmissionsVolumeChart from 'entities/Charts/components/SubmissionsVolumeChart';
import {
  CHARTS_DESCRIPTIONS_MAPPER,
  CO_OCCURRENCE_MISCONCEPTION,
  MISCONCEPTIONS_BAR_CHART,
  OVERALL_RESPONSE_BAR_CHART,
  OVERALL_RESPONSE_DISTRIBUTION_BAR_CHART,
  RUBRIC_SCORES_VS_END_OF_YEAR_SCORES,
  STRATEGY_USE_FREQUENCY,
  SUBMISSIONS_VOLUME_BAR_CHART
} from 'entities/Charts/constants';
import { ChartFilterProps } from 'entities/Charts/sdk';

import Text from 'components/Text';

const ChartsPage = () => {
  const [value, setValue] = useState<string>(OVERALL_RESPONSE_BAR_CHART);

  const [filters, setFilters] = useState<ChartFilterProps>({
    gender: '',
    grade: '',
    unit: '',
    ethnicity: '',
    state: '',
    is_low_income: '',
    is_on_individualized_education_plan: '',
    english_learner_status: '',
    standard_code: ''
  });

  return (
    <div className="flex flex-col gap-3 p-12">
      <Text variant="subtitle1">
        <Link
          to="https://docs.google.com/document/d/1_mMrd_7axcoLbqYwFA24hNQDId7ofpVHAp7eiPEqYr4/edit?tab=t.0"
          target="_blank"
          className="text-blue-600 underline hover:text-blue-800"
        >
          EdLight RPPL Report
        </Link>
      </Text>
      <SampleQuestions />
      <BarChartTabs value={value} setValue={setValue} />

      <div className="flex flex-col items-start justify-center p-10">
        <Text variant="body2" className="text-gray-600">
          {CHARTS_DESCRIPTIONS_MAPPER[value]}
        </Text>
      </div>

      <div className="flex flex-col items-center justify-center">
        <BarChartFilters filters={filters} onFilter={setFilters} />
        {value == OVERALL_RESPONSE_BAR_CHART && (
          <OverallResponseBarChart filters={filters} />
        )}
        {value == MISCONCEPTIONS_BAR_CHART && (
          <MisconceptionsBarChart filters={filters} />
        )}
        {value == SUBMISSIONS_VOLUME_BAR_CHART && (
          <SubmissionsVolumeChart filters={filters} />
        )}
        {value == OVERALL_RESPONSE_DISTRIBUTION_BAR_CHART && (
          <OverallResponseDistributionBarChart filters={filters} />
        )}
        {value == CO_OCCURRENCE_MISCONCEPTION && (
          <CoOccurrenceMisconception filters={filters} />
        )}
        {value == RUBRIC_SCORES_VS_END_OF_YEAR_SCORES && (
          <Text variant="body1">
            <ScoresPDF />
          </Text>
        )}
        {value == STRATEGY_USE_FREQUENCY && (
          <Text variant="body1">Coming soon.</Text>
        )}
      </div>
    </div>
  );
};

export default ChartsPage;
